import BaseItemId from 'owa-service/lib/contract/BaseItemId';
import deleteCalendarEventOperation from 'owa-service/lib/operation/deleteCalendarEventOperation';
import deleteCalendarEventRequest from 'owa-service/lib/factory/deleteCalendarEventRequest';
import DeleteCalendarEventRequest from 'owa-service/lib/contract/DeleteCalendarEventRequest';
import DeleteCalendarEventResponse from 'owa-service/lib/contract/DeleteCalendarEventResponse';
import EventScope from 'owa-service/lib/contract/EventScope';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { MailboxInfo } from 'owa-client-ids';
import getMailboxRequestOptions from 'owa-service-utils/lib/getMailboxRequestOptions';

/**
 * Makes the deleteCalendarEventOperation call to the server to delete the event
 * @param deleteCalendarEventId id of the calendar event that needs to be deleted
 * @param eventScope scope of event to delete, like all instances etc
 * @param mailboxInfo mailbox info of user
 * @returns a promise that returns the delete calendar event response
 */
export const deleteCalendarEventService = async (
    deleteCalendarEventId: BaseItemId,
    mailboxInfo: MailboxInfo,
    eventScope: EventScope
): Promise<DeleteCalendarEventResponse> => {
    const body: DeleteCalendarEventRequest = deleteCalendarEventRequest({
        EventId: deleteCalendarEventId,
        EventScope: eventScope,
    });
    try {
        const response = await deleteCalendarEventOperation(
            {
                Header: getJsonRequestHeader(),
                Body: body,
            },
            getMailboxRequestOptions(mailboxInfo)
        );
        return response.Body;
    } catch {
        return null;
    }
};
